import { UUID } from "../../basetypes";

export type DeliveryRules = {
  IsMailDeliveryAvailable: boolean;
  IsETicketDeliveryAvailable: boolean;
  IsDeliveryMandatory: boolean;
  IsDisplayMessageBeforeChristmas: boolean;
  ErrorShippingMandatoryButUnavailable: boolean;
  IsAtLeastOneDeliveryMethodAvailable: boolean;
  IsMultipleDeliveryMethodsAvailable: boolean;
  IsOnlyOneDeliveryMethodAvailable: boolean;
  UserCanChose: boolean;
  ModelID: string;
  IsReadonly: boolean;
  ParentModelID: string;
  ParentPropertyName: string;
  ListName: string;
  IsNewModel: boolean;
  SelfCheckForModification: boolean;
  ShippingMethodFees: ProductDeliveryShippingFee[];
}

export type ProductDeliveryShippingFee = {
  MethodId: UUID;
  NameFr: string;
  NameEn: string;
  Amount: number;
  Tax1: number;
  Tax2: number;
}

export type ProductDeliveryRules = {
  [key: number]: DeliveryRules;
}